import { render, staticRenderFns } from "./collapseBox.vue?vue&type=template&id=2b2dcb35&"
import script from "./collapseBox.vue?vue&type=script&lang=js&"
export * from "./collapseBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports